import { jsx as _jsx } from "react/jsx-runtime";
import { normalizePhone } from "@commerce-os/utils";
import { useState } from "react";
import { Input } from "./input.js";
/**
 * A Bangladeshi mobile number as people type it (`01712-345678`, `+880 1712…`, Bengali digits) → E.164
 * (`+8801712345678`). `onChange` gets `null` while it is not a valid number; the field is then marked invalid.
 */
export function PhoneInput({ defaultValue = "", onChange, ...props }) {
    const [text, setText] = useState(defaultValue);
    const invalid = text.trim() !== "" && normalizePhone(text) === null;
    return (_jsx(Input, { type: "tel", inputMode: "tel", autoComplete: "tel", value: text, "aria-invalid": invalid ? true : props["aria-invalid"], onChange: (event) => {
            setText(event.target.value);
            onChange(normalizePhone(event.target.value), event.target.value);
        }, ...props }));
}
//# sourceMappingURL=phone-input.js.map